/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Confirm_Acting_On_SharedInputs */



/**
* | output |
* | --- |
* | "shared" |
*
* @param {Chat_Tool_Confirm_Acting_On_SharedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_acting_on_shared = /** @type {((inputs?: Chat_Tool_Confirm_Acting_On_SharedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Acting_On_SharedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("gemeinsam")
	return /** @type {LocalizedString} */ ("shared")
});